<template>
  <div class="recharge-container" v-if="sn">
    <div class="scro-conent">
      <div class="device-coent" :style="{
        background: `linear-gradient(180deg, ${theamColorLight} 0%, #fbfbfb 100%)`,
      }">
        <div class="device-left" @click="show = true">
          <img class="device-image" :src="picUrl ? picUrl : require('@/assets/images/home/device.png')" />
          <img class="enter-infor-changeDevice" :src="require('@/assets/images/home/changeDevieIcon.png')" />
        </div>

        <div class="device-right">
          <p class="right-top">设备编号</p>

          <div class="right-content">
            <p class="right-foot">
              {{ sn }}
            </p>

            <p class="other-foot" v-if="deviceMoney">
              设备使用押金:<span style="color: var(--primary-color)">￥{{ deviceMoney }}</span>
            </p>
          </div>
        </div>

        <div v-if="isShowOther == 1" class="other-conent" @click="otherBuyAction">
          <p>其他设备充值</p>
          <img class="other-img" src="@/assets/images/home/rightIcon.png" />
        </div>
      </div>

      <!-- 套餐列表，分组展示 -->
      <div v-if="packageList.length" class="package-group-list">
        <!-- 横向 Tab 导航 -->
        <div class="package-tab-container">
          <div v-for="(group, groupIndex) in packageList" :key="group.groupId" :class="[
            'package-tab-item',
            { active: activeTabIndex === groupIndex },
          ]" @click="switchTab(groupIndex)">
            {{ group.groupName }}
          </div>
        </div>

        <!-- 当前选中分组的套餐列表 -->
        <div v-if="currentGroup" class="package-group">
          <div class="package-list">
            <div v-for="(item, index) in currentGroup.packages" :key="item.id" :class="[
              'package-item',
              {
                active:
                  selectedPackage.groupIndex === activeTabIndex &&
                  selectedPackage.packageIndex === index,
              },
            ]" @click="selectPackage(activeTabIndex, index, true)">
              <div class="upgrade-badge-wrapper" v-if="item.isUpgradeFlag == 1">
                <div class="upgrade-badge-text">可升级</div>
              </div>

              <div class="package-item-center">
                <p v-if="item.tips" class="package-item-tip">
                  {{ item.tips }}
                </p>

                <p class="package-item-new-price">
                  <span v-if="item.averageType == 1">
                    <span class="package-item-new-price-add">约¥</span>
                    <span v-if="item.priceHighlight" style="color: #f53333">
                      {{ item.averagePrice }}</span>
                    <span v-else> {{ item.averagePrice }}</span>

                    <span class="package-item-new-price-add">{{
                      item.averPlace
                    }}</span>
                  </span>

                  <span v-else>
                    <span class="package-item-new-price-add">¥</span>
                    <span v-if="item.priceHighlight" style="color: #f53333">
                      {{ item.newPrice }}</span>
                    <span v-else> {{ item.newPrice }}</span>
                  </span>
                </p>

                <p class="package-item-center-title">{{ item.title }}</p>

                <p class="package-item-center-desc">{{ item.packageDesc }}</p>

                <template v-if="
                  item.oldPrice || (item.averageType == 1 && item.newPrice)
                ">
                  <div class="package-item-bottom">
                    <div v-if="item.averageType == 1">
                      <div v-if="item.oldPrice && item.newPrice" class="package-item-bottom-content multiple-items">
                        <p class="package-item-old-price">
                          原价:¥{{ item.oldPrice }}
                        </p>
                        <p class="package-item-rel-price">
                          价格:¥<span style="color: var(--primary-color)">{{
                            item.newPrice
                          }}</span>
                        </p>
                      </div>

                      <div v-else class="package-item-bottom-content">
                        <p v-if="item.oldPrice" class="package-item-old-price">
                          原价:¥{{ item.oldPrice }}
                        </p>
                        <p v-if="item.newPrice" class="package-item-rel-price">
                          价格:¥<span style="color: var(--primary-color)">{{
                            item.newPrice
                          }}</span>
                        </p>
                      </div>
                    </div>

                    <div v-else class="package-item-bottom-content">
                      <p v-if="item.oldPrice" class="package-item-old-price">
                        原价:¥{{ item.oldPrice }}
                      </p>
                    </div>
                  </div>
                </template>
              </div>

              <p v-if="item.discount" class="package-item-bottom-discount">
                {{ item.discount }}
              </p>
            </div>
          </div>
        </div>
  
      </div>

      <!-- 套餐无值 -->
      <div v-else class="package-empty">
        <img class="package-empty-icon" src="@/assets/empty-order.png" />
        <p class="package-empty-text">暂无套餐</p>
      </div>

      <!-- 支付方式 -->
      <template v-if="packageList.length">

        <div class="discount-container-first" >
          <div class="discount-left">
            <p class="discount-title">优惠与折扣</p>
          </div>
         
         <template v-if="discountAmount > 0">

          <div class="discount-right" @click="enterCoupon">
            <p class="payment-text">优惠{{ discountAmount }}元</p>
            <img class="discount-icon" src="@/assets/images/home/rightIcon.png" />
          </div>
         </template>

         <template v-else>
          <div class="discount-right" @click="enterCoupon">
            <p class="payment-text">无优惠</p>
            <img class="discount-icon" src="@/assets/images/home/rightIcon.png" />
          </div>
         </template>


        </div>

        <div class="discount-container">
          <div class="discount-left">
            <p class="discount-title">支付方式</p>
          </div>
          <div class="discount-right">
            <img class="payment-icon" src="@/assets/images/home/wxIcon.png" />
            <p class="payment-text">微信支付</p>
          </div>
        </div>

      </template>



      <div v-if="packageInstruction" class="describe-conent">
        <p class="describe-tip" v-if="packageList.length">
          {{ packageInstruction }}
        </p>
      </div>
    </div>

    <div class="footer-content">
      <div class="bottom-bg-wrap">
        <!-- 协议按钮 -->

        <template>
          <div class="payment-content">
            <p v-if="agreementList.length" class="payment-infor">
              购买即同意
              <span class="mainC" @click="goToAgreement(0)">
                《{{ agreementList[0].name }}》
              </span>
              <template v-if="agreementList.length > 1">
                与
                <span class="mainC" @click="goToAgreement(1)">
                  《{{ agreementList[1].name }}》
                </span>
              </template>
              <template v-if="agreementList.length > 2">
                与
                <span class="mainC" @click="goToAgreement(2)">
                  《{{ agreementList[2].name }}》
                </span>
              </template>
            </p>
          </div>
        </template>
      </div>

      <div class="bottom-conent" v-if="packageList.length">
        <p class="footer-content-price">
          总计：<span class="mainC">¥<span style="font-size: 24px; font-weight: bold">{{
            realPayPrice
              }}</span></span>
        </p>

        <button class="payment-button" @click="finshPayAction">立即购买</button>
      </div>
    </div>

    <van-popup v-model="xyShow" position="bottom" round safe-area-inset-bottom :style="{ height: '70%' }">
      <!-- 固定头部 -->
      <div class="xy-content">
        <div class="xy-title">押金说明</div>
        <div class="xy-right">
          <img class="xy-icon" src="@/assets/tip.png" />请滑到底部
        </div>
      </div>

      <!-- 滚动区域 -->
      <div class="xy-body">
        <iframe ref="iframeRef" :src="xyUrl" class="xy-iframe"></iframe>
      </div>

      <!-- 固定底部按钮 -->
      <div class="xy-foot">
        <div class="xy-cancel" @click="xyShow = false">取消</div>
        <div class="xy-ok" :class="{ disabled: countdown > 0 }" @click="handleAgree">
          同意并支付<span v-if="countdown > 0">({{ countdown }}s)</span>
        </div>
      </div>
    </van-popup>

    <!-- 切换设备弹窗 -->
    <van-popup v-model="show" round position="bottom">
      <div class="popup-body">
        <div class="pop-header">
          <img class="pop-close" @click="closeDeviceSwitchModal" src="@/assets/images/home/close.png" />
          <p class="pop-title">切换设备</p>
          <div class="pop-add-container" @click="enterAddDevice">
            <div class="pop-header-add">
              <van-icon color="#fff" size="10px" name="plus" style="font-weight: bold" />
            </div>
            <p class="pop-add-text">添加</p>
          </div>
        </div>

        <div class="popup-content">
          <div class="switch-device-item" v-for="device in deviceList" :key="device.id">
            <img class="switch-icon" :src="device.picUrl || require('@/assets/images/home/device.png')" />
            <div>
              <p class="switch-device-item-title">{{ device.modelName }}</p>
              <p class="switch-device-item-title-tip">{{ device.sn }}</p>
            </div>
            <van-radio :name="device.id" v-model="selectedDeviceId" :checked="device.id === selectedDeviceId"
              checked-color="var(--primary-color)" class="switch-device-item-radio"></van-radio>
          </div>
        </div>

        <button class="switch-device-confirm-button" @click="confirmDeviceSwitch">
          确定
        </button>
      </div>
    </van-popup>

    <!-- 完结弹窗 -->
    <van-overlay :show="isShowUpdate" :z-index="2000" @click="closeAlertAction">
      <!-- 添加了 wrapper 层以匹配 CSS 并实现居中 -->
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="block-tip">套餐升级</p>
          <p class="block-message">
            您仅需要支付新旧套餐的差价即可完成套餐升级。同时您在完成套餐升级后，套餐权益也会自动为您升级。
          </p>

          <div class="button-group">
            <button class="btn-cancel" @click="cancelClick">不升级</button>
            <button class="btn-confirm" @click="okClick">去升级</button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>

  <div v-else>
    <div class="auth-no-device">
      <img class="package-empty-icon" src="@/assets/empty-order.png" />
      <p class="package-empty-text">暂无设备!</p>

      <p class="package-add" @click="enterAddDevice">立即添加</p>

      <p class="package-add-other" @click="otherBuyAction">其他设备充值></p>
    </div>
  </div>
</template>

<script>
import {
  getTrafficPackageList,
  getDeviceInfo,
  createOrder,
  getAgreement,
  createCheckOrder,
  getUserDeviceList,
} from "@/api/home";
import { Toast, Dialog } from "vant";
// import { Dialog } from "vant";
import { getCouponListBySn } from "@/api/user";
import { formatCouponItem } from "../../utils/couponUtils";

export default {
  data() {
    return {
      sn: "",
      modelId: "", //型号ID
      deviceName: "",
      picUrl: "",
      deviceID: "",
      deviceMoney: 0,
      selectedPackage: { groupIndex: 0, packageIndex: 0 }, // 默认选中第一个套餐
      packageList: [],
      loading: true,
      selectedPackagePrice: 0, // 默认价格
      orderID: "",
      agreementList: [],
      isHelpOtherPurchase: 0, //是否帮别人购买(1.是 0.否)
      isenterAuth: 0, //是否跳转到授权界面
      isShowOther: 0, //是否展示为其他设备充值
      type: 0, //套餐类型：1-基础套餐，2-叠加流量包
      packageInstruction: "", //套餐说明
      xyShow: false,
      xyUrl: "",
      countdown: 10,

      orderName: "", //套餐名称
      orderInfor: "", //套餐描述

      show: false, //切换设备
      deviceList: [],
      selectedDeviceId: "",
      activeTabIndex: 0, // 当前选中的 tab 索引

      isShowUpdate: false, //是否显示升级弹窗
      isUpgradeFlag: 0, // 是否能套餐升级，0否，1是

      discountAmount: 0,//优惠券金额
      claimRecordId: "",//优惠券ID

      lastSelectedId: "",//选中的套餐ID

      phone:""
    };
  },

  computed: {

    theamColorLight() {
      return this.getThemeColorWithOpacity(0.2);
    },

    theamCell() {
      return this.getThemeColorWithOpacity(0.15);
    },

    // 当前选中的分组
    currentGroup() {
      return this.packageList[this.activeTabIndex] || null;
    },

    realPayPrice() {

      if (this.selectedPackagePrice > 0) {
        // 先计算出原始结果
        let total = (this.selectedPackagePrice * 100 + this.deviceMoney * 100 - this.discountAmount * 100) / 100;
        // 判断：如果结果小于等于0，返回 0.01；否则返回保留两位的原值
        return total <= 0 ? '0.01' : total.toFixed(2);

      } else {
        return 0;
      }
    }
  },

  mounted() {
    this.isShowOther = this.$route.query.isShowOther || 0;
    this.isHelpOtherPurchase = this.$route.query.isHelpOtherPurchase || 0;
    this.isenterAuth = this.$route.query.isenterAuth;

    this.sn = this.$route.query.sn;
    this.phone = this.$route.query.phone;

    //获取
    const lastSelectedId = sessionStorage.getItem('lastSelectedId');
    this.lastSelectedId = lastSelectedId;
    sessionStorage.removeItem('lastSelectedId');

    if (this.sn) {
      this.requestDeviceInfo();
      this.getUserDeviceListAction(false);
    } else {
      this.isShowOther = 1;
      this.getUserDeviceListAction(true);
    }

    // 监听 popstate 底部返回按钮监听
    this.popstateHandler = this.handlePopState.bind(this);
    window.addEventListener("popstate", this.popstateHandler);

    ///返回的优惠券信息检查
    this.checkCouponData();
  },


  beforeDestroy() {
    // 销毁监听
    window.removeEventListener("popstate", this.handlePopState);
  },

  methods: {

    //获取主题色并应用指定的透明度
    getThemeColorWithOpacity(opacity) {

      const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue("--primary-color")
        .trim();

      if (!primaryColor) return `rgba(253, 141, 50, ${opacity})`;

      if (primaryColor.startsWith("#")) {
        let hex = primaryColor.replace("#", "");
        if (hex.length === 3) {
          hex = hex.split('').map(char => char + char).join('');
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
      if (primaryColor.startsWith("rgb")) {
        const numbers = primaryColor.match(/\d+/g);
        if (numbers && numbers.length >= 3) {
          return `rgba(${numbers[0]}, ${numbers[1]}, ${numbers[2]}, ${opacity})`;
        }
      }
      return `rgba(253, 141, 50, ${opacity})`;
    },

    handlePopState() {
      Dialog.close();
    },

    otherBuyAction() {
      this.uni.navigateTo("/home/associationDevice");
    },

    requestAgreementAction() {
      let array = [3];
      if (this.deviceMoney > 0) {
        array = [1, 3, 4];
        this.requestXyAction();
      }
      getAgreement({
        appType: "U",
        protocolTypes: array,
      }).then((res) => {
        this.agreementList = res.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        });
      });
    },

    ///获取押金协议说明
    requestXyAction() {
      getAgreement({
        appType: "U",
        protocolTypes: [4],
      }).then((res) => {
        let xyArr = res.map((item) => {
          return {
            name: item.name,
            url: item.url,
          };
        });
        this.xyUrl = xyArr.length > 0 ? xyArr[0].url : null;
      });
    },

    goToAgreement(index) {
      if (this.agreementList[index] && this.agreementList[index].url) {
        window.location.href = this.agreementList[index].url;
      } else {
        Toast.fail("协议链接无效");
      }
    },

    // 切换 Tab
    switchTab(groupIndex) {
      this.activeTabIndex = groupIndex;
      // 切换 tab 时，自动选中该分组的第一个套餐
      const currentGroup = this.packageList[groupIndex];
      if (
        currentGroup &&
        currentGroup.packages &&
        currentGroup.packages.length > 0
      ) {
        this.selectPackage(groupIndex, 0);
      } else {
        // 如果该分组没有套餐，清空选中状态
        this.selectedPackagePrice = 0;
        this.orderID = "";
        this.selectedPackage = { groupIndex, packageIndex: -1 };
      }
    },

    selectPackage(groupIndex, packageIndex, isUserClick = false) {
      this.selectedPackage = { groupIndex, packageIndex };
      // 获取选中的套餐数据（来自指定分组中的具体套餐）
      const selectedPackageData =
        this.packageList?.[groupIndex]?.packages?.[packageIndex];

      if (selectedPackageData) {
        // 更新选中套餐的价格与订单ID
        this.selectedPackagePrice = selectedPackageData.newPrice || 0;
        this.orderID = selectedPackageData.id || "";
        this.type = selectedPackageData.type;

        this.orderName = selectedPackageData.title;
        this.orderInfor = selectedPackageData.packageDesc;

        ///是否能套餐升级，0否，1是
        // 只在用户主动点击时触发升级弹窗
        if (isUserClick && selectedPackageData.isUpgradeFlag == 1) {
          this.isShowUpdate = true;
        }

        // 触发选择事件
        this.$emit("package-selected", {
          groupIndex,
          packageIndex,
          data: selectedPackageData,
        });

        ///是否能使用优惠券：0-否，1-是
        if (selectedPackageData.isCouponFlag == 1) {
          // 更新优惠券信息

          if (this.lastSelectedId != this.orderID) {

            this.checkCouponByOrderId();
          }
          
        }else{

          this.discountAmount = 0;
          this.claimRecordId = "";

        }

        this.lastSelectedId = this.orderID;

      } else {
        this.selectedPackagePrice = 0;
        this.orderID = "";
      }
    },

    // 关闭弹窗
    closeAlertAction() {
      this.isShowUpdate = false;
    },

    // 点击取消
    cancelClick() {
      this.closeAlertAction();
    },

    // 点击确认升级
    okClick() {
      this.closeAlertAction();
      this.uni.navigateTo(
        "/home/updateBuyOrder?packageId=" +
        this.orderID +
        "&terminalId=" +
        this.deviceID +
        "&isHelpOtherPurchase=" +
        this.isHelpOtherPurchase +
        "&sn="+this.sn

      );
    },

    ///下单
    finshPayAction() {
      // 检查订单ID
      if (!this.orderID) {
        Toast.fail("请联系管理员配置套餐");
        return;
      }

      // 流量叠加包检查
      if (this.type === 2) {
        this.checkOverlayPackage();
        return;
      }

      // 押金设备处理
      if (this.deviceMoney > 0) {
        this.showDepositAgreement();
        return;
      }

      // 直接创建订单
      this.finshCreateOrder();
    },

    // 检查叠加流量包
    async checkOverlayPackage() {
      const res = await createCheckOrder({
        terminalId: this.deviceID,
      });

      const { type, msg } = res;

      if (type === 1) {
        // 校验通过
        if (msg) {
          // 有有效期提示
          await this.showOverlayConfirmDialog(msg);
        }
        // 继续创建订单流程
        this.handleOrderCreation();
      } else {
        // 校验失败
        this.showErrorDialog(msg);
      }
    },

    // 显示叠加流量包确认对话框
    showOverlayConfirmDialog(expiryDate) {
      return Dialog.alert({
        title: "提示",
        message: `您当前购买的叠加流量包将会叠加到您当前使用的套餐中，有效期至${expiryDate}`,
        closeOnPopstate: false,
        confirmButtonText: "确定购买",
        confirmButtonColor: this.appData.merThemeColor,
        closeOnClickOverlay: true,
      });
    },

    // 显示错误对话框
    showErrorDialog(message) {
      return Dialog.alert({
        title: "提示",
        message: message,
        closeOnPopstate: false,
        confirmButtonText: "已知晓",
        confirmButtonColor: this.appData.merThemeColor,
      });
    },

    // 显示押金协议
    showDepositAgreement() {
      this.xyShow = true;
      this.startCountdown();
    },

    // 开始倒计时
    startCountdown() {
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 处理订单创建
    handleOrderCreation() {
      if (this.deviceMoney > 0) {
        // 押金设备，显示协议
        this.showDepositAgreement();
      } else {
        // 非押金设备，直接创建订单
        this.finshCreateOrder();
      }
    },

    ///同意按钮
    handleAgree() {
      if (this.countdown > 0) {
        return;
      }
      this.xyShow = false;
      this.finshCreateOrder();
    },

    finshCreateOrder() {
      //支付通道 1-微信官方，2-联动，3-鯤鹏
      if (this.appData.payChannel === 3) {
        this.uni.navigateTo(
          "/home/enterMiniProgram?terminalId=" +
          this.deviceID +
          "&packageId=" +
          this.orderID +
          "&isHelpOtherPurchase=" +
          this.isHelpOtherPurchase +
          "&deviceMoney=" +
          this.deviceMoney +
          "&sn=" +
          this.sn +
          "&payMomey=" +
          ((this.selectedPackagePrice * 100) / 100).toFixed(2) +
          "&orderName=" +
          this.orderName +
          "&orderInfor=" +
          this.orderInfor +
          "&isenterAuth=" +
          this.isenterAuth +
          "&claimRecordId=" +
          this.claimRecordId +
          "&discountAmount=" +
          this.discountAmount+"&phone="+this.phone
        );
      } else {
        const loadingToast = Toast.loading({
          message: "下单中...",
          forbidClick: true,
          duration: 0,
        });

        createOrder({
          terminalId: this.deviceID,
          packageId: this.orderID,
          payMode: "Wechat",
          type: "1",
          isHelpOtherPurchase: this.isHelpOtherPurchase,
          isUpgrade: "0",
          claimRecordId: this.claimRecordId,
          phone:this.phone
        }).then((res) => {
          // h5环境
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                this.onBridgeReady(res, loadingToast)
              );
            }
          } else {
            this.onBridgeReady(res, loadingToast);
          }
        });
      }
    },

    ///支付
    onBridgeReady(res, loadingToast) {
      let result = JSON.parse(res);
      let that = this;

      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: result.appId,
          timeStamp: result.timeStamp.toString(), //时间戳，
          nonceStr: result.nonceStr, //随机串
          package: result.package,
          signType: result.signType, // 签名方式，
          paySign: result.paySign, // 支付签名
        },
        function (wxR) {
          loadingToast.clear();
          if (wxR.err_msg == "get_brand_wcpay_request:ok") {
            // 支付成功
            that.$store.dispatch("updateDeviceID", that.deviceID);

            if (that.isenterAuth === "1") {
              ///跳转至认证页面
              that.uni.navigateTo("/home/auth?sn=" + that.sn + "&isFirst=1");
            } else {
              // 支付成功
              that.uni.reLaunch("/home/index");
            }
          } else if (wxR.err_msg == "get_brand_wcpay_request:cancel") {
            // 取消支付
          }
        }
      );
    },

    ///获取设备信息
    requestDeviceInfo() {
      getDeviceInfo({
        sn: this.sn,
      })
        .then((res) => {
          if (res) {
            this.deviceName = res.modelName;
            this.deviceID = res.id;
            this.selectedDeviceId = res.id;
            //充值时，隐藏押金信息
            this.deviceMoney = this.isenterAuth == "1" ? res.freezeAmount : "";
            this.modelId = res.modelId;
            this.picUrl = res.picUrl;
            // 在获取到设备信息后，再获取套餐列表
            this.getPackageList();
            this.requestAgreementAction();
          } else {
            this.resetDeviceInfo();
          }
        })
        .catch((err) => {
          this.resetDeviceInfo();
        });
    },

    resetDeviceInfo() {
      this.deviceName = "";
      this.deviceID = "";
      //充值时，隐藏押金信息
      this.deviceMoney = "";
      this.modelId = "";
      this.picUrl = "";

      this.packageList = [];
      this.agreementList = [];

      this.selectedPackagePrice = 0;
      this.orderID = "";
      this.activeTabIndex = 0;
    },

    // 获取套餐列表数据的方法
    async getPackageList() {
      this.loading = true;
      Toast.loading({ message: "加载中...", forbidClick: true });


      try {
        const res = await getTrafficPackageList({
          terminalId: this.deviceID,
          isHelpOtherPurchase: this.isHelpOtherPurchase,
        });

        const list = res?.packageGroupInfoList ?? [];
        if (!Array.isArray(list)) {
          this.packageList = [];
          return;
        }

        this.packageInstruction = res.packageInstruction;

        this.packageList = list.map((group) => ({
          groupId: group.packageGroupId,
          groupName: group.packageGroupName,
          packages: (group.packageGroupInfos ?? []).map((pkg) => {
            // 优先级：活动名称 > 首次续费 > 折扣
            let discountText = "";
            if (pkg.activityOptionName) {
              discountText = pkg.activityOptionName;
            } else if (pkg.isFirst) {
              discountText = `首充优惠`;
            } else if (pkg.discountType) {
              discountText =
                pkg.discountType === "A"
                  ? `立省${pkg.discountValue}元`
                  : `限时${pkg.discountValue}折`;
            }

            //是否能使用优惠券：0-否，1-是
            if (pkg.isCouponFlag == 1) {
              discountText = "可用券";
            }


            let averPlace = "";

            if (pkg.cycleUnit === "M") {
              // description = `每月${pkg.trafficValue}GB`;
              averPlace = "/月";
            } else if (pkg.cycleUnit === "D") {
              // description = `每天${pkg.trafficValue}GB`;
              averPlace = "/天";
            } else if (pkg.cycleUnit === "L") {
              // description = `长期有效 ${pkg.trafficValue}GB`;
            }

            return {
              isFirst: pkg.isFirst,
              id: pkg.id,
              title: pkg.name,
              newPrice: pkg.realPrice ?? pkg.price,
              oldPrice:
                pkg.realPrice != null && pkg.realPrice === pkg.price
                  ? ""
                  : pkg.price,
              tips: pkg.tags,

              discount: discountText,
              type: pkg.type || 0, // 1-基础套餐，2-叠加流量包
              packageDesc: pkg.packageDesc, //套餐描述
              averageType: pkg.averageType, //平均值类型：1-展示平均值，2-不展示平均值
              averPlace,
              averagePrice: pkg.averagePrice, //实际价格平均值
              priceHighlight: pkg.priceHighlight, //价格是否标红：false-否，true-是
              isUpgradeFlag: pkg.isUpgradeFlag, //是否能套餐升级，0否，1是
              isCouponFlag: pkg.isCouponFlag,//是否能使用优惠券：0-否，1-是
            };
          }),
        }));

        // 默认选中第一个 tab 和第一个套餐
        // this.activeTabIndex = 0;
        // if (this.packageList[0]?.packages?.length > 0) {
        //   this.selectPackage(0, 0);
        // } else {
        //   this.selectedPackagePrice = 0;
        //   this.orderID = "";
        // }

        let targetGroupIndex = 0;
        let targetPackageIndex = 0;
        let isFound = false;

        // 如果之前有选中的ID，去新的列表里找它的位置
        if (this.lastSelectedId) {
          for (let gIndex = 0; gIndex < this.packageList.length; gIndex++) {
            const group = this.packageList[gIndex];
            if (group.packages) {
              for (let pIndex = 0; pIndex < group.packages.length; pIndex++) {
                if (group.packages[pIndex].id === this.lastSelectedId) {
                  targetGroupIndex = gIndex;
                  targetPackageIndex = pIndex;
                  isFound = true;
                  break;
                }
              }
            }
            if (isFound) break;
          }
        }

        // 设置 Tab 索引
        this.activeTabIndex = targetGroupIndex;

        // 选中套餐
        if (this.packageList[targetGroupIndex]?.packages?.length > 0) {
          // 注意：第3个参数传 false，表示这是代码自动还原，不需要弹出升级弹窗等交互
          this.selectPackage(targetGroupIndex, targetPackageIndex, false);
        } else {
          this.selectedPackagePrice = 0;
          this.orderID = "";
        }

      } finally {
        this.loading = false;
      }
    },

    ///获取设备列表
    getUserDeviceListAction(flage) {
      getUserDeviceList().then((res) => {
        // 转换设备列表数据
        this.deviceList = res.map((item) => ({
          id: item.id,
          modelName: item.modelName,
          sn: item.sn,
          picUrl: item.picUrl,
        }));

        // 检查保存的设备ID是否在当前设备列表中
        if (this.deviceList.length > 0) {
          // 处理设备ID
          const savedDeviceID = this.$store.getters.getDeviceID;

          var selectDevice;

          if (this.deviceSN) {
            selectDevice = this.deviceList.find(
              (device) => device.sn === this.deviceSN
            );
          } else {
            selectDevice = this.deviceList.find(
              (device) => device.id === savedDeviceID
            );
          }

          if (!selectDevice) {
            selectDevice = this.deviceList[0];
          }

          if (selectDevice && flage) {
            this.selectedDeviceId = selectDevice.id;
            this.sn = selectDevice.sn;
            this.requestDeviceInfo();
          }
        }
      });
    },

    ///切换设备-确认按钮点击事件
    confirmDeviceSwitch() {
      if (!this.selectedDeviceId) {
        this.$toast.fail("请选择设备");
        return;
      }
      // 获取选中设备的信息
      const selectedDevice = this.deviceList.find(
        (device) => device.id === this.selectedDeviceId
      );
      if (selectedDevice) {
        this.selectedDeviceId = selectedDevice.id;
        this.sn = selectedDevice.sn;
        this.requestDeviceInfo();
      }
      // 关闭弹窗
      this.closeDeviceSwitchModal();
    },

    closeDeviceSwitchModal() {
      // 关闭弹窗
      this.show = false;
    },

    enterAddDevice() {
      this.uni.navigateTo("/home/addDevice");
      this.closeDeviceSwitchModal();
    },

    // 选择优惠券
    enterCoupon() {


      this.uni.navigateTo("/coupon/coupon?isUpgrade=0&sn=" +
        this.sn + "&packageId=" + this.orderID + "&amount=" + this.selectedPackagePrice +
        "&lastSelectedId=" + this.lastSelectedId + "&claimRecordId=" + this.claimRecordId);
    },

    // 优惠券返回数据处理
    checkCouponData() {
      const dataStr = sessionStorage.getItem('selected_coupon_data');
      if (dataStr) {
        try {

          sessionStorage.removeItem('selected_coupon_data');
          const data = JSON.parse(dataStr);
          let item = formatCouponItem(data)
          this.discountAmount = item.discountAmount;
          this.claimRecordId = item.claimRecordId;
        } catch (e) {
        }
      }
    },


    /*存在可用券时，需要调接口获取最优惠的优惠券*/
    checkCouponByOrderId() {

      // if (this.lastSelectedId) {
      //   return
      // }

      const params = {
        sn: this.sn,//设备sn
        packageId: this.orderID,//套餐ID
        amount: this.selectedPackagePrice,//套餐原价（元）
        isUpgrade: 0,//是否套餐升级：0否，1是 必传
      };

      getCouponListBySn(params).then((res) => {
        /* 可用部分 */
        let itemArray = (res.usableList || []).map(item => formatCouponItem(item));

        if (itemArray) {
          let item = itemArray[0];
          this.discountAmount = item.discountAmount;
          this.claimRecordId = item.claimRecordId;
        }
      });
    },



  }
};
</script>

<style lang="less" scoped>
.recharge-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: #f2f2f2;
}

.scro-conent {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 210px;
}

/* 设备内容区域 */
.device-coent {
  display: flex;
  margin: 32px;
  border-radius: 16px;
  padding: 24px;
  align-items: center;
  position: relative;
}

/* 左侧设备图片区域 */
.device-left {
  position: relative; // ✅ 给容器加定位基准
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: white;
  border-radius: 16px;
  margin-right: 24px;

  .device-image {
    width: 120px;
    height: 120px;
    object-fit: contain;
    border-radius: 16px;
  }

  .enter-infor-changeDevice {
    position: absolute; // ✅ 绝对定位到图片底部
    bottom: 0;
    left: 0;
    width: 100%; // ✅ 宽度撑满容器（与图片等宽）
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/* 右侧设备信息区域 */
.device-right {
  display: flex;
  flex-direction: column;

  /* 设备编号标题 */
  .right-top {
    color: #1a1a1a;
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
  }

  /* 设备信息内容容器 */
  .right-content {
    display: flex;
    align-items: center;
    width: 100%;
  }

  /* 设备编号 */
  .right-foot {
    color: #333333;
    font-size: 22px;
    font-weight: 500;
  }
}

/* 右上角其他设备充值按钮 */
.other-conent {
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 22px;
  font-weight: 500;
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  padding: 8px 12px;

  transition: all 0.3s ease;

  .other-img {
    width: 24px;
    height: 24px;
    margin-left: 6px;
  }
}

/* 设备押金信息 */
.other-foot {
  font-size: 20px;
  color: #666666;
  position: absolute;
  right: 24px;
}

/* Tab 导航容器 */
.package-tab-container {
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px;
  background-color: #f2f2f2;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    display: none;
  }
}

/* Tab 项 */
.package-tab-item {
  flex-shrink: 0;
  padding: 12px 32px 20px 20px;
  margin-right: 16px;
  font-size: 30px;
  color: #999999;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  position: relative;

  &.active {
    color: #333333;
    font-weight: bold;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 48px;
      height: 8px;
      background-color: var(--primary-color);
      border-radius: 4px;
    }
  }

  &:last-child {
    margin-right: 0;
  }
}

.package-group-title {
  color: #000000;
  font: 32px;
  font-weight: bold;
  margin-left: 32px;
}

// --- 修改点9：角标样式 Start ---
.upgrade-badge-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  width: 180px;
  height: 180px;
  overflow: hidden;
  border-top-right-radius: 16px;
  /* 与父元素圆角保持一致 */
  z-index: 10;
  pointer-events: none;
}

.upgrade-badge-text {
  position: absolute;
  top: 12px;
  right: -30px;
  width: 120px;
  height: 35px;
  line-height: 35px;
  background: #f53333;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  transform: rotate(45deg);
  /* 旋转45度 */
}

// --- 角标样式 End ---

.package-list {
  display: flex;
  margin: 40px 30px 10px 30px;
  flex-wrap: wrap;
  gap: 32px;
  row-gap: 32px;
}

.package-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(50% - 30px);
  height: 332px;
  border-radius: 16px;
  background: #ffffff;

  position: relative;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;

  &.active {
    border: 1px solid var(--primary-color);

    .package-item-center {
      background-color: v-bind("theamCell");
    }

    .package-item-bottom {
      background-color: var(--primary-color) !important;

      .package-item-old-price {
        color: #ffffff !important;
      }

      .package-item-rel-price {
        color: #ffffff !important;

        span {
          color: #ffffff !important;
        }
      }
    }
  }

  .package-item-center {
    width: 100%;
    height: 280px;
    border-radius: 13px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .package-item-bottom {
    font-size: 20px;
    color: #666666;
    width: 100%;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    text-align: center;
  }

  .package-item-bottom:not(:empty) {
    border-top: 1px solid #f5f6fa;
  }

  .package-item-bottom-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  /* 单个标签时居中显示 */
  .package-item-bottom-content:not(.multiple-items) {
    justify-content: center !important;
  }

  /* 两个标签时左右排放 */
  .package-item-bottom-content.multiple-items {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
    height: 100% !important;
    padding: 0 24px !important;
    gap: 10px !important;
  }

  .package-item-old-price {
    font-size: 20px;
    color: #848992;
    text-decoration: line-through;
    white-space: nowrap;
  }

  /* 两个标签时左边文本样式 */
  .package-item-bottom-content.multiple-items .package-item-old-price {
    position: absolute;
    left: 24px;
  }

  .package-item-rel-price {
    font-size: 20px;
    color: #848992;
    white-space: nowrap;
  }

  /* 两个标签时右边文本样式 */
  .package-item-bottom-content.multiple-items .package-item-rel-price {
    position: absolute;
    right: 24px;
  }

  .package-item-center-title {
    font-size: 21px;
    font-weight: bold;
    color: white;
    height: 44px;
    width: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 10px;
    background-color: var(--primary-color);
    border-radius: 22px;
  }

  .package-item-center-desc {
    font-size: 20px;
    color: #24262b;
    padding-left: 15px;
    padding-right: 15px;
  }

  .package-item-new-price {
    font-size: 65px;
    color: #24262b;
    font-weight: bold;
    margin: 0px 0px 5px 0px;
    display: flex;
    align-items: baseline;
    gap: 2px;

    .package-item-new-price-add {
      font-size: 24px;
    }

    span {
      display: flex;
      align-items: baseline;
      gap: 2px;
    }
  }

  .package-item-tip {
    font-size: 18px;
    background-color: var(--primary-color);
    color: white;
    border-radius: 18px;
    text-align: center;
    white-space: normal;
    word-break: break-all;
    padding: 4px 20px;
    margin-bottom: 10px;
    margin-top: 0px;
  }

  .package-item-bottom-discount {
    width: 152px;
    height: 42px;
    background-color: #f53333;
    border-radius: 8px 100px 100px 0px;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    line-height: 42px;
    position: absolute;
    top: -45px;
    left: -1px;
  }
}

// 骨架屏样式
.package-skeleton {
  display: flex;
  margin-left: 30px;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

// 空数据样式
.package-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
}

.package-empty-icon {
  width: 342px;
  height: 264px;
}

.package-empty-text {
  font-size: 30px;
  color: #666666;
  margin-top: 72px;
}

.discount-container-first {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-top: 40px;
  box-sizing: border-box;
  background: white;
  border-bottom: 1px solid #f5f6fa;
}

.discount-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
  background: white;
  border-bottom: 1px solid #f5f6fa;
}

.discount-left {
  display: flex;
  align-items: center;
}

.discount-right {
  display: flex;
  align-items: center;
}

.discount-title {
  font-size: 30px;
  color: #24262b;
  line-height: 1;
}

.discount-select {
  font-size: 30px;
  color: var(--primary-color);
  line-height: 1;
}

.discount-icon {
  width: 32px;
  height: 32px;
  margin-left: 10px;
}

.tip-line {
  height: 2px;
  background-color: var(--line-color);
  margin: 0 30px;
}

.payment-icon {
  width: 32px;
  height: 32px;
  display: block;
}

.payment-text {
  font-size: 30px;
  color: #24262b;
  margin-left: 10px;
  line-height: 1;
}

.footer-content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  z-index: 100;

  .bottom-bg-wrap {
    // background-color: #f5f6fa;

    .payment-content {
      display: flex;
      background-color: #f2f2f2;
      padding: 0px 32px 0px 32px;

      .payment-infor {
        font-size: 22px;
        color: #848992;

        .mainC {
          color: var(--primary-color);
          font-weight: bold;
        }
      }
    }
  }
}

.bottom-conent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 32px 20px 32px;

  .footer-content-price {
    font-size: 32px;
    color: #24262b;
    font-weight: bold;
  }

  .payment-button {
    width: 254px;
    height: 70px;
    border: none;
    color: #ffffff;
    font-size: 30px;
    font-weight: bold;
    background-color: var(--primary-color);
    border-radius: 16px;
  }
}

.describe-conent {
  display: flex;
  padding: 0px 32px;

  .describe-tip {
    color: #848992;
    font-size: 26px;
    white-space: pre-wrap;
    word-break: break-word;
  }
}

.xy-content {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 32px 32px 0px 32px;
}

// /* 居中标题，屏幕中心 */
.xy-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 32px;
  font-weight: bold;
  color: #24262b;
  text-align: center;
}

/* 右侧内容靠右 */
.xy-right {
  margin-left: auto;
  /* 推到最右边 */
  // margin-right: 32px;
  display: flex;
  align-items: center;
  font-size: 28px;
  font-weight: normal;
  color: var(--primary-color);

  .xy-icon {
    width: 32px;
    height: 32px;
    margin-right: 4px;
    /* 图标和文字间距 */
  }
}

.xy-body {
  flex: 1;
  overflow: auto;
  height: calc(100% - 200px);
}

.xy-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.xy-foot {
  position: sticky;
  bottom: 0;
  display: flex;
  background-color: white;
  justify-content: space-between;
  /* 两边对齐，中间间隔用 margin */
  margin: 20px;
  padding-bottom: 20px;
  z-index: 10;
}

.xy-cancel,
.xy-ok {
  flex: 1;
  text-align: center;
  padding: 24px 0;
  border-radius: 16px;
  cursor: pointer;
  background-color: #f5f6fa;
  color: #999999;
}

.xy-ok {
  margin-left: 26px;
  /* 间隔的一半 */
  background-color: var(--primary-color);
  color: #ffffff;
}

.xy-ok.disabled {
  color: #999;
  cursor: not-allowed;
  background-color: #f5f6fa;
}

/* 弹窗三段式布局 */
.popup-body {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  height: 70vh;

  .pop-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #f2f5fa;
  }

  .pop-title {
    flex: 1;
    text-align: center;
    font-weight: 700;
    font-size: 36px;
    color: var(--text-color);
  }

  .pop-close {
    width: 48px;
    height: 48px;
  }

  .pop-add-container {
    display: flex;
    align-items: center;

    .pop-header-add {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: var(--primary-color);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .pop-add-text {
      font-size: 32px;
      color: var(--primary-color);
      margin-left: 8px;
    }
  }
}

.popup-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 0;
}

.switch-device-item {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 32px;
  background-color: #f7f8fa;
  border-radius: 20px;
}

.switch-device-item-title {
  font-size: 30px;
  color: #000000;
  padding-left: 8px;
  margin-bottom: 4px;
}

.switch-device-item-title-tip {
  font-size: 26px;
  color: #848992;
  padding-left: 8px;
  margin-top: 0px;
}

.switch-device-item-radio {
  margin-left: auto;
  margin-right: 32px;
}

.switch-icon {
  width: 112px;
  height: 112px;
  object-fit: contain;
  padding: 10px;
}

/* 底部按钮固定定位 */
.switch-device-confirm-button {
  position: sticky;
  bottom: 0;
  background-color: var(--primary-color);
  border: none;
  border-radius: 20px;
  height: 100px;
  width: calc(100% - 32px);
  margin: 0 16px calc(10px + env(safe-area-inset-bottom));
  color: #ffffff;
  z-index: 10;
}

.auth-no-device {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .package-empty-icon {
    margin-top: 120px;
    width: 342px;
    height: 264px;
  }

  .package-empty-text {
    font-size: 30px;
    color: #666666;
    margin-top: 72px;

    .package-empty-text-tip {
      color: var(--primary-color);
    }
  }

  .package-add {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    width: calc(100vw - 80px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .package-add-other {
    color: var(--primary-color);
  }
}

/* --- 套餐升级弹窗样式 --- */

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .block {
    width: 550px;
    background-color: #fff;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1001;

    .block-tip {
      font-size: 34px;
      color: #24262b;
      margin-top: 32px;
      margin-bottom: 40px;
    }

    .block-message {
      font-size: 30px;
      color: #4e5969;
      margin: 0px 32px 40px 32px;
    }

    .button-group {
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin-top: 22px;
      position: relative;
      border-top: 1px solid #f2f5fa;

      .btn-cancel,
      .btn-confirm {
        flex: 1;
        height: 88px;
        border: none;
        background: transparent;
        font-size: 32px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;

        &:active {
          background-color: #f9f9f9;
        }
      }

      .btn-cancel {
        color: #999999;
        border-right: 1px solid #f2f5fa;
      }

      .btn-confirm {
        color: var(--primary-color);
      }
    }
  }
}
</style>
